import { render, staticRenderFns } from "./ReactionRoles.vue?vue&type=template&id=f183a2b4"
import script from "./ReactionRoles.vue?vue&type=script&lang=js"
export * from "./ReactionRoles.vue?vue&type=script&lang=js"
import style0 from "./ReactionRoles.vue?vue&type=style&index=0&id=f183a2b4&prod&lang=scss"
import style1 from "./ReactionRoles.vue?vue&type=style&index=1&id=f183a2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports